import React from 'react';

export const EmptyState = ({ icon: Icon, title, hint, action, testId = 'sales-empty-state' }) => (
  <div data-testid={testId} className="py-12 px-4 text-center rounded-3xl border border-dashed border-slate-300/80 bg-white/50 backdrop-blur-xl flex flex-col items-center justify-center space-y-3">
    {Icon && (
      <div className="w-14 h-14 rounded-2xl bg-teal-50 text-teal-700 border border-teal-100 flex items-center justify-center shadow-sm">
        <Icon className="h-6 w-6" />
      </div>
    )}
    <p className="font-semibold text-slate-900">{title}</p>
    {hint && <p className="text-sm text-slate-500 max-w-xs">{hint}</p>}
    {action}
  </div>
);
